import type { IMultiSportPartnerPayload } from '../types/MultiSportPartnerPayload.types'
import useApi from '@/composables/api/useApi'

export default function () {
  const { partnersApiUrl } = useRuntimeConfig().public
  const { fetchApi } = useApi((partnersApiUrl as string) ?? '')
  
  const createMultisportPartner = async (body: IMultiSportPartnerPayload) => {
    return await fetchApi('/multisport', {
      method: 'POST',
      body: JSON.stringify(body),
    })
  }

  return {
    createMultisportPartner,
  }
}
